import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../style/adminreport.css";
import "../../../style/designer-milling-responsive.css";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { apiAxios } from "../../../utils/apiAxios";
import { getAuthToken, getUserIdFromToken } from "../../../utils/auth";
import { DesignerReportOrderRow } from "./Interface/DesignerReportOrderRow";
import { DesignerReportOrderType } from "./DesignerReportOrderType";
import Select from "react-select";

const DesignerReport = () => {
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [filters, setFilters] = useState({
    orderId: "",
    clinic: "",
    type: "",
    hub: "",
    designer: "",
    partner: "",
    paymentType: "",
    paymentStatus: "",
    status: "",
    fromDate: "",
    toDate: "",
  });
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [orders, setOrders] = useState<DesignerReportOrderRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [orderCounts, setOrderCounts] = useState({ activeOrders: 0, pendingReview: 0, completed: 0, });
  const [orderDropdown, setOrderDropdown] = useState<{ caseID: number; orderID: string }[]>([]);
  const [orderTypes, setOrderTypes] = useState<DesignerReportOrderType[]>([]);
const totalOrders = orders.length;

 const getBaseStatus = (status: string) => {
  const s = (status || "").toLowerCase();

  if (s.includes("cancelled")) return "cancelled";
  if (s === "completed") return "completed";

  return "pending";
};


const completedOrders = orders.filter(
  (x) => getBaseStatus(x.status) === "completed"
).length;

const cancelledOrders = orders.filter(
  (x) => getBaseStatus(x.status) === "cancelled"
).length;

const pendingOrders = orders.filter(
  (x) => getBaseStatus(x.status) === "pending"
).length;

  const handleChange = (e: any) => {
    const { name, value } = e.target; setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setFilters({
      orderId: "",
      clinic: "",
      type: "",
      hub: "",
      designer: "",
      partner: "",
      paymentType: "",
      paymentStatus: "",
      status: "",
      fromDate: "",
      toDate: "",
    });

     setSearch("");
    setStartDate(null);
    setEndDate(null);
    setOrders([]);
    
  };
  useEffect(() => {
    fetchOrderCounts();
    fetchOrderDropdown();
    fetchOrderTypes();
  }, []);


  const loadReport = async () => {
    try {
      setLoading(true);
const formatDate = (date: Date | null) =>
  date ? date.toISOString().split("T")[0] : null;
const res = await apiAxios.get(
  `${API_BASE_URL}/Desginer/GetDesignerOrderReport`,
  {
    params: {
      orderID: filters.orderId || null,
      orderTypeID: filters.type ? Number(filters.type) : null,
      fromDate: formatDate(startDate),
      toDate: formatDate(endDate),
      search: search || null,
    },
    headers: {
      AuthorizationData: getAuthToken(),
    },
  }
      );
      if (res.data?.isSuccess) {
       
        const mapped = res.data.singleData.map((x: any) => ({
          orderId: x.orderID,
          clinic: x.clinicName || "N/A",
          type: x.orderType || "N/A",
          assignedHub: x.hubName || "N/A",
          assignedDesigner: x.designerName || "N/A",
          partner: x.deliveryName || "N/A",
          paymentType: x.paymentType || "N/A",
          paymentStatus: x.paymentStatus || "N/A",
          expectedDelivery: x.createdDate || "N/A",
          phone: x.mobileNo || "N/A",
          payment: x.amount || 0,
          status: x.status || "N/A"
        }));

        setOrders(mapped);

      }

    } catch (err) {
      console.error("Report error:", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchOrderTypes = async () => {
    try {
      const token = getAuthToken();

      const res = await apiAxios.get(
        `${API_BASE_URL}/Desginer/order-type-dropdown`,
        {
          headers: { AuthorizationData: token },
        }
      );

      if (res.data?.data) {
        setOrderTypes(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load order types", err);
    }
  };
  const fetchOrderDropdown = async () => {
    try {
      const token = getAuthToken();
      const userId = getUserIdFromToken();

      const res = await apiAxios.get(
        `${API_BASE_URL}/Desginer/order-dropdownDesignerReport`,
        {
          params: { userId: userId },
          headers: { AuthorizationData: token },
        }
      );
      if (res.data?.data) {
        setOrderDropdown(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load order dropdown", err);
    }
  };
  const fetchOrderCounts = async () => {
    try {
      const token = getAuthToken();
      const res = await apiAxios.get(`${API_BASE_URL}/MillingHub/GetOrderCounts`, {
        headers: { AuthorizationData: token },
      });
      const data = res.data?.data?.[0];
      if (data) {
        setOrderCounts({
          activeOrders: data.activeOrders ?? 0,
          pendingReview: data.pendingReview ?? 0,
          completed: data.completed ?? 0,
        });
      }
    } catch (err) {
      console.error("Failed to load order counts", err);
    }
  };
  const columns = useMemo(
    () => [
      {
        name: "Order ID",
        selector: (row: DesignerReportOrderRow) => row.orderId,
        sortable: true,
      },


      {
        name: "Type",
        selector: (row: DesignerReportOrderRow) => row.type,
      },
{
  name: "Status",
  cell: (row: DesignerReportOrderRow) => {
    const statusStyles: Record<string, { bg: string; color: string }> = {
      completed: { bg: "#d1fae5", color: "#065f46" },
      ready_for_delivery: { bg: "#dbeafe", color: "#1e40af" },
      pending_acceptance: { bg: "#fef3c7", color: "#92400e" },
      delay_report: { bg: "#fee2e2", color: "#991b1b" },
      pending: { bg: "#f3f4f6", color: "#374151" },
      cancelled: { bg: "#fecaca", color: "#b91c1c" },
    };

    const status = (row.status || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_");

    const style = statusStyles[status] || {
      bg: "#f3f4f6",
      color: "#374151",
    };

    return (
      <span
        style={{
          backgroundColor: style.bg,
          color: style.color,
          padding: "5px 10px",
          borderRadius: "4px",
          fontSize: "12px",
          fontWeight: 500,
          display: "inline-block",
          textTransform: "capitalize",
          whiteSpace: "nowrap",
        }}
      >
        {row.status || "-"}
      </span>
    );
  },
  width:"180px"
}
    ],
    []
    
  );
const exportExcel = () => {
  const exportData = orders.map((d) => ({
    "Order ID": d.orderId,
    "Type": d.type,
    "Status": d.status,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Designer Report"
  );

  XLSX.writeFile(workbook, "Designer_Report.xlsx");
};

const exportPDF = () => {
  const doc = new jsPDF("landscape");

  // =========================
  // REPORT HEADING
  // =========================
  doc.setFontSize(18);
  doc.setFont("helvetica", "normal");

  // Page center
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.text(
    "Designer Order Report",
    pageWidth / 2,
    15,
    { align: "center" }
  );

  // =========================
  // TABLE
  // =========================
  const tableColumn = [
    "Order ID",
    "Type",
    "Status",
  ];

  const tableRows = orders.map((d) => [
    d.orderId,
    d.type,
    d.status,
  ]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,

    // Heading ke neeche table
    startY: 25,

    styles: {
      fontSize: 8,
      halign: "center",
      valign: "middle",
    },

    headStyles: {
      fillColor: [22, 160, 133],
      halign: "center",
    },
  });

  doc.save("Designer_Report.pdf");
};

 
  return (
    <div className="container-fluid">
      <div className="mb-4">
        <h4 className="mb-4">Designer Order Report</h4>
        <p className="text-muted">
          Track all orders
        </p>
      </div>

      <div className="order-status-bar mb-4">

        <div className="status-col">
          <h3>{totalOrders}</h3>
          <span className="status-badge bgnone">Total Orders</span>

        </div>
        <div className="status-col">
          <h3>{pendingOrders}</h3>
          <div className="status-badge warning">
            <i className="bi bi-clock-history"></i>
            Pending
          </div>
        </div>
        <div className="status-col">


          <h3>{completedOrders}</h3>
          <div className="badge-box badge-success">
            <i className="bi bi-check-circle-fill completed-icon"></i>
            Completed
          </div>
        </div>

        <div className="status-col">
    <h3>{cancelledOrders}</h3>
    <div className="status-badge danger">
      <i className="bi bi-x-circle-fill"></i>
      Cancelled
    </div>
  </div>
      </div>

      {/* FILTER PANEL */}

      <div className="premium-card mb-4 p-3">

        <div className="row g-3 align-items-end">

          {/* Order ID */}
          <div className="col-md-12 col-12 col-sm-12 col-lg-3">
            <label className="form-label">Order ID</label>
          <Select
options={[...(orderDropdown || [])]
  .sort(
    (a: any, b: any) =>
      new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
  )
  .map((item: any) => ({
    value: item.orderID,
    label: `${item.orderID} - ${new Date(
      item.createdDate
    ).toLocaleDateString("en-GB")}`,
  }))}
  value={
    filters.orderId
      ? {
          value: filters.orderId,
          label: `OrderID-${filters.orderId}`,
        }
      : null
  }
  onChange={(selected) =>
    setFilters((prev) => ({
      ...prev,
      orderId: selected ? String(selected.value) : "",
    }))
  }
  placeholder="Select Order ID"
  isSearchable
  isClearable
/>
          </div>
        


          {/* Order Type */}
          <div className="col-md-12  col-12 col-sm-12 col-lg-3">
            <label className="form-label">Order Type</label>
         <Select
  options={orderTypes.map((item) => ({
    value: item.orderTypeID,
    label: item.orderTypeName,
  }))}
  value={
    filters.type
      ? {
          value: Number(filters.type),
          label:
            orderTypes.find(
              (x) => x.orderTypeID === Number(filters.type)
            )?.orderTypeName || "",
        }
      : null
  }
  onChange={(selected) =>
    setFilters((prev) => ({
      ...prev,
      type: selected ? String(selected.value) : "",
    }))
  }
  placeholder="Select Type"
  isSearchable
  isClearable
/>
          </div>
          

          {/* Status */}
{/* <div className="col-md-3 col-lg-2">
  <label className="form-label">Status</label>
  <select
    className="form-select"
    name="status"
    value={filters.status}
    onChange={handleChange}
  >
    <option value="">All Status</option>
    <option value="Pending">Pending</option>
    <option value="Completed">Completed</option>
    <option value="InProgress">In Progress</option>
    <option value="Rejected">Rejected</option>
  </select>
</div> */}

          {/* Start Date */}
                 <div className="col-md-12  col-12 col-sm-12 col-lg-3 position-relative">
   
            <label className="form-label">Start Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              placeholderText="Start Date"
              className="form-control pe-5"
              dateFormat="dd-MM-yyyy"
              portalId="root"
            />
            <i className="bi bi-calendar3 calendar-icon mtcustom"></i>
          </div>

          {/* End Date */}
           <div className="col-md-12  col-12 col-sm-12 col-lg-3 position-relative">
            <label className="form-label">End Date</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="End Date"
              className="form-control pe-5"
              dateFormat="dd-MM-yyyy"
              portalId="root2"
            />
            <i className="bi bi-calendar3 calendar-icon mtcustom"></i>
          </div>

          {/* Search */}
          <div className="col-md-4 col-lg-3">
            <label className="form-label">Search</label>
            <input
              className="form-control"
              placeholder="Global Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Buttons (aligned bottom) */}
          <div className="col-md-4 col-lg-3 d-flex gap-2">

            <button className="btn btn-primary"
              onClick={loadReport}>
            Search
            </button>

            <button
              className="btn btn-secondary   d-flex align-items-center"
              onClick={handleClear}
            >
              Clear
            </button>

          </div>

        </div>

      </div>





      {/* TABLE */}

      <div className="premium-card p-4 round">
        <div className="d-flex justify-content-end mb-3">

          <button
            className="btn btn-success mx-1"
            onClick={exportExcel}
            disabled={orders.length === 0}
          >
            <i className="bi bi-file-earmark-excel"></i>
              Export Excel
          </button>

          <button
            className="btn btn-danger"
            onClick={exportPDF}
            disabled={orders.length === 0}
          >
            <i className="bi bi-file-earmark-pdf"></i>
             Export PDF
          </button>

        </div>
        <DataTable
          columns={columns}
          data={orders}
          pagination
          highlightOnHover
          striped
          responsive
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />
      </div>
    </div>
  );
};

export default DesignerReport;